import { Text, Stack, Group, Title } from "@mantine/core"
import { CountryLabel, HelpHover } from "@tfg/ui"
import { useTranslation } from "react-i18next"

import { useListSuppliersQuery } from "~/pages/Brand/Suppliers/List/supplierHooks"
import { COUNTRIES } from "~/utils/countries"
import { useGetOperations } from "~/utils/operations"

type ProductionSitesInformationProps = {
  supplierEmail: string
}

const ProductionSitesInformation = ({
  supplierEmail,
}: ProductionSitesInformationProps) => {
  const { t } = useTranslation("organizationSettings")
  const operations = useGetOperations()
  const suppliersQuery = useListSuppliersQuery({
    searchSupplier: supplierEmail,
    fetchDataOptions: { pageIndex: 0, pageSize: 1 },
    filters: {
      supplierType: undefined,
      country: undefined,
    },
    orderBy: {},
  })

  const productionSites =
    suppliersQuery.data?.suppliers[0]?.productionSites?.map(
      (productionSite) => productionSite
    )

  const activities = [
    ...new Set(
      productionSites?.flatMap((productionSite) =>
        productionSite?.operations?.map(
          (operation) => operations[operation.activity?.name]?.name
        )
      )
    ),
  ]

  return (
    <Stack gap="sm" w="100%" p="xs">
      <Title order={3}>{t("supplierSettings.productionSites.title")}</Title>
      {!productionSites || productionSites?.length === 0 ? (
        <Text fw={500}>
          {t("supplierSettings.productionSites.noProductionSitesLabel")}
        </Text>
      ) : (
        productionSites?.map((productionSite) => (
          <Group key={productionSite.id} w="100%" justify="space-between">
            <Text fw={500}>{productionSite.name}</Text>
            <Group wrap="nowrap">
              <CountryLabel
                countryIso3166={productionSite.countryIso3166}
                countriesMapper={COUNTRIES}
                inline
              />
              {activities.length > 0 && (
                <HelpHover>
                  <Text>{`${t("supplierSettings.productionSites.productionOperations")}: ${activities.join(", ")}`}</Text>
                </HelpHover>
              )}
            </Group>
          </Group>
        ))
      )}
    </Stack>
  )
}

export default ProductionSitesInformation
